module.exports = __webpack_public_path__ + "img/antes_despues_258.34f47e8c.png";